import TracksMenu from './TracksMenu';
import AudioTracksList from './AudioTracksList';
import TextTracksList from './TextTracksList';

TracksMenu.AudioTracksList = AudioTracksList;
TracksMenu.TextTracksList = TextTracksList;

export { default } from './TracksMenu';
